import React, { useEffect, useState } from 'react';
import { useCIAMAuth } from '../hooks/useCIAMAuth';

export const Debug = (props: any) => {
  const [displayExtendTime, setDisplayExtendTime] = useState(props.extendTime);
  const [remaining, setRemaining] = useState(0);
  const ciamAuth = useCIAMAuth();
  
  useEffect(() => {
    setDisplayExtendTime(props.extendTime);
  }, [props.extendTime]);
  

  useEffect(() => {
    const extendTimerInterval = setInterval(() => {
      setDisplayExtendTime((prev: any) => prev - 1000 < 0 ? 0 : prev - 1000);
      setRemaining(Math.ceil(props.getRemainingTime() / 1000));
    }, 1000);
    return () => clearInterval(extendTimerInterval);
  }, []);

  const  formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  return (
    <div>
      {ciamAuth?.config?.debugMode && <>
        <h2><b>Session Details</b></h2>
        
        <div>Logged In User: {ciamAuth?.ciamSession?.ciamUser?.sub}</div>
        <div>Token issued at : {ciamAuth?.ciamSession?.ciamUser?.iat ? new Date(ciamAuth.ciamSession.ciamUser.iat * 1000).toLocaleString() : ''}</div>
        {ciamAuth?.ciamSession?.ciamUser?.exp ?
          <>
            <div>Token expire at : {new Date(ciamAuth.ciamSession.ciamUser.exp * 1000).toLocaleString()} </div>
            <div>Redis expires at : {new Date((ciamAuth.ciamSession.ciamUser.exp - 15 * 60) * 1000).toLocaleString()}</div>
          </>
          : null}
        <br />
        <h2><b>Timer Details</b></h2>
        <div>Extend Timer: {formatTime(Math.ceil(props.extendTime / 1000))}</div>
        <div>Popup Timer: {formatTime(props.popupTimer)}</div>
        <div></div>
        <br></br>
        <div>User State: {props.state}</div>
        <div>Time to go for Idle status: {formatTime(remaining)} seconds</div>
        <div>Token will renew after : {formatTime(Math.ceil(displayExtendTime / 1000))}</div>
      {/* <div>If state is idle, Pop up will appear in : {formatTime(((ciamAuth?.ciamSession?.ciamUser?.exp - expTime) * 1000) - (Date.now() / 1000) - popupTimer)}</div> */}
      <br />
      </>}
    </div>
  );
};
